<template lang="pug">
  v-footer(color="primary",dark height="auto")
    v-container(fluid )
      v-row(style="min-height: 400px;")
        v-col(align="center" cols="12" md="4")
          v-card(dark color="primary" height="100%" )
            ContactInfo
        v-col(align="center" cols="12" md="4")
          v-card.pa-6(dark color="primary" height="100%" )
            v-row(justify="center")
              v-col()
                v-btn(icon href="https://www.facebook.com/cityofrefugeucc/" target="_blank" )
                  v-icon.mdi.mdi-facebook(x-large)
              v-col()
                v-btn(icon href="http://www.twitter.com/cityofrefugeucc" target="_blank" )
                  v-icon.mdi.mdi-twitter(x-large)
              v-col()
                v-btn(icon href="https://www.youtube.com/channel/UCPd1Uyo-ATz_O07DRL8jY0g" target="_blank")
                  v-icon.mdi.mdi-youtube(x-large)
              v-col()
                v-btn(icon href="http://www.instagram.com/cityofrefugeucc" target="_blank")
                  v-icon.mdi.mdi-instagram(x-large)
              v-col()
                v-btn(icon href="mailto:info@cityofrefugeucc.org" target="_blank")
                  v-icon.mdi.mdi-email(x-large)
            v-row
              v-col(cols="12")
                gMap
        v-col(align="center" cols="12" md="4" )
          v-card(dark color="primary" height="100%" style="padding: 50px" )
            v-row()
              v-col(cols="12")
                span#prayer Request Prayer
            v-row()
              v-col(cols="12")
                span#prayer Receive E-Newsletter
    v-row.my-5(justify="center")
      | City Of Refuge UCC &copy; {{ new Date().getFullYear() }}
    //- v-col.text-center(cols='12')
</template>

<script>
import gMap from '../components/footer/googleMap';
import Dialog from '../components/header/dialog';
import { getSunday } from '../plugins/getDays';
import ContactInfo from '../components/contact/info';
export default {
  components: {
    gMap,
    Dialog,
    ContactInfo
  },
  created() {
    this.getSunday = getSunday();
  },
  data() {
    return {
      getSunday: null,
      theName: name
    };
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.iconBtn, #prayer
  cursor pointer
  border 2px solid #ffffff
  font-size 100%
  padding 8px

  &:hover
    color #000
    background-color #fff
</style>
